import { Injectable, } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subscription  } from 'rxjs';
import { map,tap } from 'rxjs/operators';
import {User} from 'src/app/components/services/user'
import {Visitante} from 'src/app/components/services/visitante'
import { environment } from 'src/environments/environment';



@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    // observables usuario
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser$: Observable<User>;


     // observables visitante
     private currentVisitSubject: BehaviorSubject<Visitante>;
     public currentVisit$: Observable<Visitante>;

    public baseUrl=environment.apiUrl;

         
    private inicializado: number =0;
    constructor(private http: HttpClient, private router:Router) {
      this.currentUserSubject = new BehaviorSubject<User>({id:0, nombre:'',password:'',nombrecompleto:'',exp:'',token:''});
    
     var t:string;


       if(localStorage.getItem("currentUser"))
       {                     
           this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')!));          
       }
       else{
        this.currentUserSubject = new BehaviorSubject<User>({id:0, nombre:'',password:'',nombrecompleto:'',exp:'',token:''});
       }


       if(localStorage.getItem("currentVisitante"))
       {                     
           this.currentVisitSubject = new BehaviorSubject<Visitante>(JSON.parse(localStorage.getItem('currentVisitante')!));          
       }
       else{
           this.currentVisitSubject = new BehaviorSubject<Visitante>({id:0, nombre:'',idioma:'',mail:''});
       }
         

      

       this.currentUser$ = this.currentUserSubject.asObservable();
       this.currentVisit$ = this.currentVisitSubject.asObservable();
      
       this.inicializado=1;
        
    }

    
    public GetEntornoImages(item:string) {      
        console.log("imagenesentorno","get",this.baseUrl + 'get_entorno_images.php');
      return this.http.post<any>(this.baseUrl + 'get_entorno_images.php',{params:item })
      .pipe(map(item => {
       
      return item;
      }));        
   }
  
  
    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        
        return this.http.post<any>(this.baseUrl + 'loginnema.php',  { username, password })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes       
                console.log("devuelto loginnema",user);       
                console.log("user.nombre",user.nombre); 
                if(user.nombre===username)
               {             
                   console.log("entro");
                localStorage.setItem('username', user.nombre);  
                localStorage.setItem('JSESSIONid', user.token); 
                localStorage.setItem('JSESSION_expire', user.exp);                     
               
                localStorage.setItem('currentUser', JSON.stringify(user));
                
               
   
              this.currentUserSubject.next(user);
              
                const redirect = '/room-list/';    
               this.router.navigate([redirect]);
                
                
                
               }   
               else
               {
                   console.log("no entro");
               
                this.logout();
               }
               
                
                return user;
            })
            
            );

    }
    public DownloadFichero(fichero:string) {
        const url = '/assets/pdfs/'+fichero;
       
        
        return this.http.get(url, { headers: new HttpHeaders({       
          'Content-Type': 'application/octet-stream',
          }), responseType: 'blob'}).pipe (
          tap (
            // Log the result or error
            data => console.log('You received data'),
            error => console.log(error)
          )
         );
        }


    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');       
        localStorage.removeItem('username');
        localStorage.removeItem('JSESSIONid');
        localStorage.removeItem('JSESSION_expire');
        
        
        
        this.currentUserSubject.next({id:0, nombre:'',password:'',exp:'',token:''});
       
        
    }

    isloggedIn(){
        
        if(this.currentUserSubject.value===null)
            return false;
        const user = this.currentUserSubject.value;
        const logged = user && user.token;
        
        return true;
    }
   
  

    public GetMenu() {       
               
        let idioma:string;
      
        if(localStorage.getItem("idioma")){
            idioma=localStorage.getItem("idioma")!;
        }
        else{  
            idioma='1';
            localStorage.setItem('idioma',idioma);  
        }
       
        console.log("peticion a "+this.baseUrl + 'getmenu.php');

        return this.http.post<any>(this.baseUrl + 'getmenu.php',{params: idioma })
        .pipe(map(opcionesMenu => {            
            localStorage.setItem('menu',JSON.stringify(opcionesMenu));  
            
        return opcionesMenu;
        }));        
     }



     public GetTextes() {       
               
        let idioma:string;
      
        if(localStorage.getItem("idioma")){
            idioma=localStorage.getItem("idioma")!;
        }
        else{  
            idioma='1';
            localStorage.setItem('idioma',idioma);  
        }
       
        console.log("peticion a "+this.baseUrl + 'gettextes.php');

        return this.http.post<any>(this.baseUrl + 'gettextes.php',{params: idioma })
        .pipe(map(textos => {            
            localStorage.setItem('textes',JSON.stringify(textos));  
            
        return textos;
        }));        
     }


     public GetGaleria() {       
               
        let idioma:string;
      
        if(localStorage.getItem("idioma")){
            idioma=localStorage.getItem("idioma")!;
        }
        else{  
            idioma='1';
            localStorage.setItem('idioma',idioma);  
        }
       
        console.log("peticion a "+this.baseUrl + 'getgaleria.php');

        return this.http.post<any>(this.baseUrl + 'getgaleria.php',{params: idioma })
        .pipe(map(textos => {            
            localStorage.setItem('galeria',JSON.stringify(textos));  
            
        return textos;
        }));        
     }

     
     public GetAptVillaSirenaItems() {       
               
        let idioma:string;
      
        if(localStorage.getItem("idioma")){
            idioma=localStorage.getItem("idioma")!;
        }
        else{  
            idioma='1';
            localStorage.setItem('idioma',idioma);  
        }
       
        

        return this.http.post<any>(this.baseUrl + 'getaptvillasirenaitems.php',{params: idioma })
        .pipe(map(textos => {            
            localStorage.setItem('getaptvillasirenaitems',JSON.stringify(textos));  
            
        return textos;
        }));        
     }
     public GetGaleriaImages(item:string) {      
        console.log("imagenes",this.baseUrl + 'get_galeria_images.php');
        return this.http.post<any>(this.baseUrl + 'get_galeria_images.php',{params:item })
        .pipe(map(item => {
         
        return item;
        }));        
     }
     public GetAptCalaFigueraItems() {       
               
        let idioma:string;
      
        if(localStorage.getItem("idioma")){
            idioma=localStorage.getItem("idioma")!;
        }
        else{  
            idioma='1';
            localStorage.setItem('idioma',idioma);  
        }
       
        

        return this.http.post<any>(this.baseUrl + 'getaptcalafigueraitems.php',{params: idioma })
        .pipe(map(textos => {            
            localStorage.setItem('getaptcalafigueraitems',JSON.stringify(textos));  
            
        return textos;
        }));        
     }

     public GetRooms() {       
               
        let idioma:string;
      
        if(localStorage.getItem("idioma")){
            idioma=localStorage.getItem("idioma")!;
        }
        else{  
            idioma='1';
            localStorage.setItem('idioma',idioma);  
        }
       
        console.log("peticion a "+this.baseUrl + 'getrooms.php');

        return this.http.post<any>(this.baseUrl + 'getrooms.php',{params: idioma })
        .pipe(map(textos => {            
            localStorage.setItem('rooms',JSON.stringify(textos));  
            
        return textos;
        }));        
     }


     public GetEntorno() {       
               
        let idioma:string;
      
        if(localStorage.getItem("idioma")){
            idioma=localStorage.getItem("idioma")!;
        }
        else{  
            idioma='1';
            localStorage.setItem('idioma',idioma);  
        }
       
        console.log("peticion a "+this.baseUrl + 'getentorno.php');

        return this.http.post<any>(this.baseUrl + 'getentorno.php',{params: idioma })
        .pipe(map(textos => {            
            localStorage.setItem('entorno',JSON.stringify(textos));  
            
        return textos;
        }));        
     }

     

     public GetIdiomas() {       
               
        let idioma;
        idioma="1";
        console.log("peticion a "+this.baseUrl + 'getidiomas.php');
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

        return this.http.post<any>(this.baseUrl + 'getidiomas.php',{params: idioma },{headers: headers})
        .pipe(map(idiomas => {            
            localStorage.setItem('idiomas',JSON.stringify(idiomas));  
            
        return idiomas;
        }));        
     }
    

     public EnviarMail(contacto: string){               
        return this.http.post<any>(this.baseUrl + 'newsletter.php',{ params: contacto})
        .pipe(map(
            res=>{              
                console.log(res);
                return res;
            })
        );        
     }

    

}

